/**
 * Created by shubham on 11/6/18.
 */

import { Component } from '@angular/core';
import { SessionHandler } from '../../shared/services/session-handler.service';
import { Router,ActivatedRoute } from '@angular/router';
import { Http,Headers } from '@angular/http';
import { HttpService } from '../../shared/services/http.service'
import { MdDialog } from '@angular/material';
import { APPCONFIG } from '../../config';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonService } from '../../shared/services/common.service';
import { Observable } from 'rxjs/Rx';
import { DialogComponent } from '../../dialog/dialog.component';
import { TranslateService } from 'ng2-translate';
import { FileUploader } from 'ng2-file-upload';

@Component({
    template: require('./addFile.component.html')
})

export class AddFileComponent {
    data: any = [];
    dialogRef;
    FileUploadForm: FormGroup;
    FileUploadFormDetails: any;
    userDetails: any;
    isSystemAdmin:boolean = false;
    isBUManager:boolean = false;
    isRegionalAdmin:boolean = false;
    isServiceOwner:boolean = false;
    isTradePartner:boolean = false;
    isSubUser:boolean = false;
    public uploader: FileUploader;
    public headers = new Headers();
    accessToken: any;
    public URL: any;
    csvName: string;
    showError: boolean = false;
    errorMsg: any;
    Countries = [];
    tempCountries =[{
        "id": "",
        "name": "All",
        "code": "",
        "active": true,
        "createdAt": "2019-02-26T12:49:39.329Z"
    }];
    tempBusinessUnits = [{
        "id": "",
        "name": "All",
        "codeISAM": "",
        "active": true,
        "createdAt": "2018-04-06T20:05:02.397Z",
        "updatedAt": "2018-05-31T06:41:54.303Z"
    }];
    BusinessUnit = [];
    uploadAction: boolean = false;
    formData: any;
    formDataFlag: boolean = false;

    constructor(private router: Router, private route: ActivatedRoute, private Http: Http, private httpService: HttpService,  public sessionHandler: SessionHandler,
                private formBuilder: FormBuilder, public dialog: MdDialog,  private translate: TranslateService, private commonService: CommonService) {

        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if(this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0){
            this.accessToken  = this.userDetails['accessToken'];

            if(this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            }
            if(this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        this.URL = APPCONFIG.URL+"/uploadCsv/dataUpload";

        this.uploader = new FileUploader({url: this.URL, disableMultipart: true});
        this.getCountries();
    }

    public getCountries(){
        this.httpService.getRequest('lookupDataOperationsApi/v1/countriesForAdmin').subscribe(
            
            res => { this.saveCountries(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveCountries(res){
        if(res && res.items){
            //this.Countries = res.items;
            this.Countries = this.tempCountries.concat(res.items);
        }
        this.FileUploadForm.controls['countryId'].disable();
        this.FileUploadForm.controls['businessUnitId'].disable();
        this.httpService.onEnd();
    }

    public getBusinessUnitByCountryId(countryId) {
        if(countryId){
            this.httpService.getRequest('lookupDataOperationsApi/v1/buForSelectedCountry/'+countryId).subscribe(
                res => { this.saveBusinessUnitByCountryId(res); },
                err => { this.httpService.onEnd(); }
            );
        }
    }

    saveBusinessUnitByCountryId(res) {
        if(res && res.items){
            //this.BusinessUnit = res.items;
            this.BusinessUnit = this.tempBusinessUnits.concat(res.items);
        }
        this.httpService.onEnd();
    }

    buildForm() {
        this.FileUploadForm = this.formBuilder.group({
            selectedRadioValue: this.formBuilder.control('Role_Maintenance', [Validators.required]),
            countryId: this.formBuilder.control('', [Validators.required]),
            businessUnitId: this.formBuilder.control('', [Validators.required]),
        });
        this.FileUploadForm.valueChanges.subscribe(data => {
            this.FileUploadFormDetails = this.FileUploadForm.getRawValue();
            this.FileUploadFormDetails['includesHeader'] = true;
            this.FileUploadFormDetails.validate = this.FileUploadForm.valid;
        });

        this.FileUploadForm.get('selectedRadioValue').valueChanges.subscribe(data=> {
            if(data != null){
                if(data == 'Role_Maintenance'){
                    this.uploadAction = false;
                    this.FileUploadForm.controls['countryId'].disable();
                    this.FileUploadForm.controls['businessUnitId'].disable();
                } else if(data == 'User_Migration'){
                    this.uploadAction = true;
                    this.FileUploadForm.controls['countryId'].enable();
                    this.FileUploadForm.controls['businessUnitId'].enable();
                }
            }
        });

        this.FileUploadForm.get('countryId').valueChanges.subscribe(data=> {
            this.FileUploadForm.controls['businessUnitId'].setValue('');
            //this.BusinessUnit = [];
            this.BusinessUnit = this.tempBusinessUnits;
            if(data != null){
                this.getBusinessUnitByCountryId(data);
            }
        });
    }

    public fileupload() {
        this.formData = new FormData();
        for (let i in this.uploader.queue) {
            if (!this.uploader.queue[i].isSuccess) {
                if(this.uploader.queue[i]._file.type == 'text/csv' || this.uploader.queue[i]._file.type == ''
                    || (this.uploader.queue[i]._file.type.indexOf("excel") != -1)) {
                    this.csvName = this.uploader.queue[i]._file.name;

                    if(this.uploader.queue[i]._file.type == ''){
                        if(this.csvName.indexOf(".")){
                            let checkExtension = this.csvName.substring(this.csvName.indexOf(".")+1,this.csvName.length);
                            if(checkExtension != 'csv'){
                                this.showError = true;
                                this.formDataFlag = false;
                                this.errorMsg = 'invalid_csv_format';
                            }
                        }
                    }

                    if(this.uploader.queue[i]._file.size/1024/1024 < 5) {
                        this.showError = false;
                        this.formData.append('file', this.uploader.queue[i]._file);
                        this.formDataFlag = true;
                    } else {
                        this.showError = true;
                        this.uploader.queue[i].isError = true;
                        this.formDataFlag = false;
                        this.errorMsg = 'file_too_large';
                    }
                } else{
                    this.showError = true;
                    this.formDataFlag = false;
                    this.errorMsg = 'invalid_csv_format';
                }
            }
        }
    }

    public downloadSampleCSVFile(){
        let sampleMigrationData;
        let fileName = "User_migration_sample.csv";
        if(this.FileUploadFormDetails['selectedRadioValue'] == 'Role_Maintenance'){
            sampleMigrationData = [['LDAP ID', 'LDAP ROLE', 'Business Unit Name', 'Customer Number']];
            fileName = "Role_migration_sample.csv"
        } else{
            sampleMigrationData = [['LDAP ID (Optional)', 'First Name', 'Last Name', 'Email', 'Company Name', 'Company Phone', 'Company Address', 'Customer No', 'Language (Optional)', 'LDAP ROLE (Optional)']];
        }

        let csvContent = "data:text/csv;charset=utf-8,";
        sampleMigrationData.forEach(function(infoArray, index){
            let dataString = infoArray.join(",");
            csvContent += index < sampleMigrationData.length ? dataString+ "\n" : dataString;
        });
        let encodedUri = encodeURI(csvContent);
        let link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", fileName);
        link.click();
    }

    public saveUploadCSVData() {
        this.httpService.showLoader();
        this.Http
            .post(this.URL+'?action='+this.FileUploadFormDetails['selectedRadioValue']+'&includesHeader='+this.FileUploadFormDetails['includesHeader']+'&countryId='+this.FileUploadFormDetails['countryId']+'&businessUnitId='+this.FileUploadFormDetails['businessUnitId']+'&apiKey='+APPCONFIG.apiKey+'&access-token='+this.accessToken, this.formData, {headers: this.headers})
            .toPromise()
            .then(res => this.setFormData(res.json()))
            .catch((error:any) => Observable.throw(this.httpService.handleError(error.json(),'uploadCsv/dataUpload')))
    }

    public setFormData(res){
        this.uploader = new FileUploader({url: this.URL,disableMultipart: true});
        if(res){
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = "req_rcvd_to_be_notified_by_mail";
            this.dialogRef.afterClosed().subscribe(result => {
                this.router.navigateByUrl('/app/file-upload/list');
            });
        } else if(res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'unable_to_upload';
            this.httpService.onEnd();
        }
    }

    ngOnInit(): void {
        this.buildForm();
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/file-upload/add-file/addFile.component.ts